import type { GameStatusData } from './types'

export interface CompletedPlayerPerspective {
  id: string
  log: string
  playerJsonLog: unknown | null
  position: number
  roleBoard: GameStatusData['roleBoard']
}

export interface CompletedPerspectiveSeat {
  id: string
  position: number
}

function validGodBoard(board: GameStatusData['roleBoard']): boolean {
  return board === null || (
    board.version === 1
    && board.viewerSeatId === null
    && board.editable === false
    && Array.isArray(board.seats)
  )
}

function validSeatBoard(
  board: GameStatusData['roleBoard'],
  seatId: string,
): boolean {
  return board === null || (
    board.version === 1
    && board.viewerSeatId === seatId
    && board.editable === false
    && board.hypothesisVersion === null
    && Array.isArray(board.seats)
  )
}

export function selectCompletedPlayerPerspective<T extends CompletedPlayerPerspective>(
  input: {
    data: T | null | undefined
    isError: boolean
    isPending: boolean
    selectedSeat: CompletedPerspectiveSeat | null | undefined
    statusRoleBoard: GameStatusData['roleBoard'] | undefined
  },
): T | null {
  const {
    data,
    isError,
    isPending,
    selectedSeat,
    statusRoleBoard,
  } = input
  if (
    isError
    || isPending
    || !data
    || !selectedSeat
    || !validGodBoard(statusRoleBoard ?? null)
    || data.id !== selectedSeat.id
    || data.position !== selectedSeat.position
    || !validSeatBoard(data.roleBoard, selectedSeat.id)
  ) {
    return null
  }
  return data
}
